module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: ({
      width: _vm.chartWidth
    }),
    attrs: {
      "id": "slate-int-calculator-chart-header"
    }
  }, [_c('transition-group', {
    class: ['sentence-slider', _vm.forwardOrBack],
    attrs: {
      "tag": "div",
      "name": "slide"
    }
  }, _vm._l(([_vm.currentSlide]), function(number) {
    return _c('div', {
      key: number
    }, [_c('div', {
      staticClass: "sentence",
      domProps: {
        "innerHTML": _vm._s(_vm.sentences[_vm.currentSlide])
      }
    })])
  })), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentSlide !== 0),
      expression: "currentSlide!==0"
    }],
    staticClass: "button-container previous",
    on: {
      "click": _vm.backButtonPress
    }
  }, [_c('tr', [_c('td', {
    staticClass: "arrow"
  }, [_vm._v("←")]), _vm._v(" "), _c('td', {
    staticClass: "button"
  }, [_vm._v(_vm._s(_vm.prevButton))])])]), _vm._v(" "), _c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentSlide !== (_vm.slideData.length - 1)),
      expression: "currentSlide!==(slideData.length - 1)"
    }],
    staticClass: "button-container next",
    on: {
      "click": _vm.forwardButtonPress
    }
  }, [_c('tr', [_c('td', {
    staticClass: "button"
  }, [_vm._v(_vm._s(_vm.nextButton))]), _vm._v(" "), _c('td', {
    staticClass: "arrow"
  }, [_vm._v("→")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/andrewkahn/.nvm/versions/node/v6.10.1/lib/~/vue-cli/~/vue-loader/lib/template-compiler.js?id=data-v-b573eeea!/Users/andrewkahn/.nvm/versions/node/v6.10.1/lib/~/vue-cli/~/vue-loader/lib/selector.js?type=template&index=0!./components/ChartHeader.vue
// module id = 113
// module chunks = 0